import { LoginResponseData } from '@EHSNavigator/backend';
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_GET_SESSION,
  USER_UPDATE_TOKEN,
  SET_LOADING,
} from './constants';

export interface UserState {
  loading?: boolean;
  error?: string | null;
  userInfo: LoginResponseData | null;
  isAuthenticated: boolean;
}

interface Action {
  type: string;
  payload?: string;
}

export const USER_INITIAL_STATE: UserState = {
  loading: true,
  error: null,
  userInfo: null,
  isAuthenticated: false,
};

export const userLoginReducer = (
  state: UserState = USER_INITIAL_STATE,
  action: Action,
) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { ...USER_INITIAL_STATE, loading: true };
    case USER_LOGIN_SUCCESS:
      return {
        ...USER_INITIAL_STATE,
        loading: false,
        userInfo: action.payload,
        isAuthenticated: true,
      };
    case USER_LOGIN_FAIL:
      return {
        ...USER_INITIAL_STATE,
        loading: false,
        error: action.payload,
        isAuthenticated: false,
      };
    case USER_LOGOUT:
      return { ...USER_INITIAL_STATE, isAuthenticated: false, loading: false };
    case USER_UPDATE_TOKEN:
      return {
        ...state,
        userInfo: action.payload,
      };
    case USER_GET_SESSION:
      return {
        ...USER_INITIAL_STATE,
        userInfo: action.payload,
        loading: false,
        isAuthenticated: action.payload !== null ? true : false,
      };
    case SET_LOADING:
      return {
        ...USER_INITIAL_STATE,
        loading: false,
      };

    default:
      return state;
  }
};
